// removed by extract-text-webpack-plugin
module.exports = {"overlay":"_22AkAfZEDhmaPXuBW0mqko","wrap":"_1Y5ukYvYdX24plbl-IPDEO","preloader":"_1M7JWJQTE6VlUaEDsYD2ZR","label":"_1TxMqOTlCzfQ9YbHoJ5iAr"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LegacyAuth/LegacyAuth.scss
// module id = 2939
// module chunks = 0